export const externalAccess = {
  "externalAccess.title": "Connected applications",
  "externalAccess.subtitle": "Allow your applications to read and search the help available to you in an organization.",
  'externalAccess.failed': 'The connection could not be loaded or changed. Try again.',
  'externalAccess.scopeLost': 'This connection does not have the required permission.',
  'externalAccess.accessLost': 'Access is unavailable. Check your account and organization membership.',
  'externalAccess.resync': 'The saved comparison is no longer valid. Review and reset observation here.',
  'externalAccess.limit': 'A connection or storage limit has been reached. Remove unused connections or narrow observation.',
  'externalAccess.conflict': 'This connection changed elsewhere. Reload its saved state before trying again.',
  'externalAccess.throttled': 'Too many requests. Wait before trying again.',
  'externalAccess.missing': 'This connection is no longer available.',
  'externalAccess.invalid': 'Check the name, expiry and observation settings.',
  'externalAccess.expiryDays': 'Access expires in days (1–365)',
  'externalAccess.noExpiry': 'No expiration',
  'externalAccess.watch': 'Help update observation',
  'externalAccess.watchEnabled': 'Enable observation for this connection',
  'externalAccess.watchExplain': 'An agent requests snapshots and acknowledges them after saving its report. This setting does not start a schedule.',
  'externalAccess.watchLanguage': 'Preferred help language',
  'externalAccess.watchContexts': 'Sections to observe',
  'externalAccess.allContexts': 'All readable help',
  'externalAccess.contextsUnavailable': 'Available sections could not be loaded. Saved section choices are preserved.',
  'externalAccess.keptContexts': 'Some saved sections are currently unavailable and remain selected until you choose all help or change the selection.',
  'externalAccess.copy': 'Copy',
  'externalAccess.copied': 'Copied',
  'externalAccess.copyFailed': 'Copy failed. Select and copy the value manually.',
  'externalAccess.unsaved': 'Unsaved external integration settings',
  'externalAccess.create': 'Create API key',
  'externalAccess.name': 'Name',
  'externalAccess.read': 'Read help',
  'externalAccess.readDetail': 'Read and search authorized help, illustrations, section context and application links. No clinical records or content editing.',
  'externalAccess.sync': 'Track help updates',
  'externalAccess.syncDetail': 'Keep a technical comparison and acknowledge processed help updates. This does not change help content.',
  'externalAccess.working': 'Saving…',
  'externalAccess.consentTitle': 'Connect an agent',
  'externalAccess.consentDetail': 'Review the application, organization and permissions before allowing access.',
  'externalAccess.client': 'Requesting application',
  'externalAccess.unverified': 'The application supplied its own name. Check the callback address and organization before approving.',
  'externalAccess.loopback': 'The callback goes to a local application. Continue only if you started this request in a trusted desktop client.',
  'externalAccess.approve': 'Allow access',
  'externalAccess.deny': 'Deny',
  'externalAccess.clinic': 'Organization',
  'externalAccess.callback': 'Callback address',
  'externalAccess.resource': 'Requested resource',
  'externalAccess.permissions': 'Permissions',
  'externalAccess.back': 'Back to integrations',
  'externalAccess.state.active': 'Active',
  'externalAccess.state.expired': 'Expired',
  'externalAccess.state.revoked': 'Revoked',
  'externalAccess.state.unavailable': 'Access unavailable',
  'externalAccess.checkpoint.disabled': 'Observation disabled',
  'externalAccess.checkpoint.uninitialized': 'Awaiting first snapshot',
  'externalAccess.checkpoint.ready': 'Comparison saved',
  'externalAccess.checkpoint.pending': 'Awaiting agent acknowledgement',
  'externalAccess.checkpoint.expired': 'Comparison expired; reset required',
  'externalAccess.unknown': 'Unknown state',
  'externalAccess.connection': 'Connection',
  'externalAccess.selectClinic': 'Select this connection’s organization in the application to change its settings. Revocation remains available.',
  'externalAccess.rotate': 'Replace key',
  'externalAccess.revoke': 'Revoke access',
  'externalAccess.reload': 'Reload saved state',
  'externalAccess.reloadFailed': 'The saved state could not be loaded. Your draft is retained.',
  'externalAccess.reloaded': 'The form now shows the saved state.',
  'externalAccess.state': 'State',
  'externalAccess.created': 'Created',
  'externalAccess.expires': 'Expires',
  'externalAccess.keyPrefix': 'Key prefix',
  'externalAccess.lastUsed': 'Last used',
  'externalAccess.lastAck': 'Last acknowledged snapshot',
  'externalAccess.baselineExpires': 'Comparison valid until',
  'externalAccess.reset': 'Reset saved comparison and pending updates',
  'externalAccess.resetExplain': 'Reset discards the saved comparison and unacknowledged batch. The next request initializes a new baseline. It does not acknowledge an unfinished report.',
  'externalAccess.resetRequired': 'Changing these settings requires an explicit reset of the saved comparison.',
  'externalAccess.save': 'Save observation',
  'externalAccess.revokeTitle': 'Revoke this connection?',
  'externalAccess.rotateTitle': 'Replace this API key?',
  'externalAccess.revokeDetail': 'The agent loses access immediately. This connection cannot be reactivated.',
  'externalAccess.rotateDetail': 'The old key stops working immediately. Observation is preserved. Copy the replacement key when it appears.',
  'externalAccess.kind.oauth': 'Connected application',
  'externalAccess.kind.key': 'API key',
  'externalAccess.manageNamed': 'Manage {name}',
  'externalAccess.openNamed': 'Open {name}',
  'externalAccess.secretTitle': 'Your new API key',
  'externalAccess.secretDetail': 'This is the only display of the complete key. Copy it into your client’s secret settings. Keep it out of URLs and chat messages.',
  'externalAccess.secretHide': 'I have saved the key — close',
  'externalAccess.mcpUrl': 'MCP address',
  'externalAccess.apiUrl': 'REST API address',
  'externalAccess.empty': 'No connections yet',
  'externalAccess.emptyDetail': 'Connect a compatible client with OAuth or create a key in the selected organization.',
  'externalAccess.addresses': 'Connection addresses',
  'externalAccess.copyNamed': 'Copy {label}',
  'externalAccess.facts': 'Connection details',
  'externalAccess.access': 'Access',
  'externalAccess.secretDismiss': 'I have saved the key — hide it',
  'externalAccess.readChip': 'Reading',
  'externalAccess.syncChip': 'Updates',
  "designAccess.title": "Source and design access",
  "designAccess.subtitle": "Connect an assistant to read project source and save design proposals. Application changes require separate approval and implementation.",
  "designAccess.read": "Read project source",
  "designAccess.readDetail": "Read the project repository, components, styles and saved proposals. This does not grant access to clinical data.",
  "designAccess.write": "Save design proposals",
  "designAccess.writeDetail": "Save inert files together with their explanation and version history. This does not change the running application.",
  "designAccess.consentDetail": "Grant this client account-level access to project source and design proposals. Review the requested permissions and callback.",
  "designAccess.ineligible": "Your account is not authorized for source and design access. Contact an administrator.",
  "designAccess.open": "Manage source and design connections",
  "designAccess.emptyDetail": "Add the MCP address as an OAuth connector in your assistant, then review and approve the request here.",
  "designAccess.cancel": "Keep access",
  "designProposals.subtitle": "Drafts an assistant saved through the design connection. Viewing a draft does not change the application.",
  "designProposals.open": "Open design drafts",
  "designProposals.empty": "No drafts yet",
  "designProposals.emptyDetail": "Drafts an assistant saves through the design connection appear here.",
  "designProposals.connect": "How to connect an assistant",
  "designProposals.failed": "Design drafts could not be loaded. Try again.",
  "designProposals.forbidden": "Design drafts are available only to accounts with source and design access.",
  "designProposals.notFound": "This draft or its version is no longer available.",
  "designProposals.layoutManifest": "Organized",
  "designProposals.layoutInferred": "No page list",
  "designProposals.layoutInvalid": "Needs fixing",
  "designProposals.layoutInferredDetail": "The draft has no page list, so its pages are shown in file order.",
  "designProposals.layoutInvalidDetail": "This draft's page list cannot be used, so its pages are shown in file order. Ask the assistant to correct it.",
  "designProposals.columnTitle": "Draft",
  "designProposals.columnArea": "Area",
  "designProposals.columnLayout": "Layout",
  "designProposals.columnPages": "Pages",
  "designProposals.columnVersions": "Versions",
  "designProposals.columnUpdated": "Updated",
  "designProposals.columnAuthor": "Saved by",
  "designProposals.page": "Page",
  "designProposals.width": "Preview width",
  "designProposals.widthFull": "Desktop",
  "designProposals.widthTablet": "Tablet",
  "designProposals.widthPhone": "Phone",
  "designProposals.fullScreen": "Full screen",
  "designProposals.frameTitle": "Draft page: {title}",
  "designProposals.version": "Version",
  "designProposals.versions": "Versions",
  "designProposals.versionOption": "{date} · {author}",
  "designProposals.latest": "latest",
  "designProposals.savedBy": "Saved",
  "designProposals.unknownAuthor": "Unknown account",
  "designProposals.noPages": "This draft has no pages to show.",
  "designProposals.explanation": "Explanation",
  "designProposals.noExplanation": "This draft has no explanation.",
  "designProposals.olderVersion": "You are viewing an earlier version.",
  "designProposals.showLatest": "Show the latest",
} as const
